import { render, staticRenderFns } from "./message-dialog.vue?vue&type=template&id=61fa3239"
import script from "./message-dialog.vue?vue&type=script&lang=js"
export * from "./message-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61fa3239')) {
      api.createRecord('61fa3239', component.options)
    } else {
      api.reload('61fa3239', component.options)
    }
    module.hot.accept("./message-dialog.vue?vue&type=template&id=61fa3239", function () {
      api.rerender('61fa3239', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/email-bulk-message/message-dialog.vue"
export default component.exports